import { useEffect } from "react";
import { motion } from "framer-motion";
import { INTRO_DURATION } from "@/lib/intro";
import { SLOGAN } from "@/data/site";
import { asset } from "@/lib/assets";

const EASE = [0.22, 1, 0.36, 1];

const Preloader = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, INTRO_DURATION * 1000);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      className="fixed inset-0 z-[90] flex flex-col items-center justify-center bg-ink"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      data-testid="intro-curtain"
      aria-hidden="true"
    >
      <div className="relative">
        <motion.span
          className="absolute -inset-3 rounded-full border border-volt"
          initial={{ scale: 0.4, opacity: 0 }}
          animate={{ scale: [0.4, 1.8], opacity: [0.8, 0] }}
          transition={{ duration: 1.3, delay: 0.9, ease: "easeOut" }}
        />
        <motion.img
          src={asset("/assets/ui/snapx-mark.webp")}
          alt=""
          width={336}
          height={336}
          className="h-24 w-24 md:h-28 md:w-28"
          initial={{ scale: 0, rotate: -160, opacity: 0 }}
          animate={{ scale: [0, 1.12, 1], rotate: 0, opacity: 1 }}
          transition={{ duration: 1, times: [0, 0.7, 1], delay: 0.15, ease: EASE }}
          data-testid="intro-mark"
        />
      </div>
      <span className="mt-6 block overflow-hidden py-1">
        <motion.img
          src={asset("/assets/ui/snapx-wordmark.webp")}
          alt="SNAPX TECHNOLOGIES LLP"
          width={525}
          height={120}
          className="h-8 w-auto md:h-10"
          initial={{ y: "120%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.65, ease: EASE }}
          data-testid="intro-wordmark"
        />
      </span>
      <motion.p
        className="font-serif-display mt-4 text-lg italic text-white/45"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1.1 }}
        data-testid="intro-slogan"
      >
        {SLOGAN}
      </motion.p>
      <motion.div
        className="absolute bottom-0 left-0 h-0.5 bg-volt"
        initial={{ width: "0%" }}
        animate={{ width: "100%" }}
        transition={{ duration: INTRO_DURATION - 0.4, ease: "easeInOut" }}
      />
    </motion.div>
  );
};

export default Preloader;
